module.exports = __webpack_public_path__ + "static/tabs-style-dont-9bbc5953bbe1604a090d4bb7344b5423.png";